export type AssignableAgentLike = {
  id: string
  name?: string | null
  email?: string | null
}

function agentSortKey(a: AssignableAgentLike): string {
  return (a.name || a.email || a.id || '').trim().toLocaleLowerCase()
}

export function orderAgentsForAssignMenu<T extends AssignableAgentLike>(
  agents: T[],
  selectedId: string | null | undefined,
): T[] {
  const sorted = [...agents].sort((a, b) => {
    const cmp = agentSortKey(a).localeCompare(agentSortKey(b), undefined, {
      sensitivity: 'base',
    })
    if (cmp !== 0) return cmp
    return String(a.id).localeCompare(String(b.id))
  })

  if (!selectedId) return sorted

  const idx = sorted.findIndex((a) => a.id === selectedId)
  if (idx <= 0) return sorted

  const selected = sorted[idx]!
  return [selected, ...sorted.slice(0, idx), ...sorted.slice(idx + 1)]
}
